import React from 'react';

const centerStyle = {
  display:        'flex',
  flexDirection:  'column',
  alignItems:     'center',
  justifyContent: 'center',
  minHeight:      '100vh',
  gap:            '1.25rem',
  padding:        '2rem',
  textAlign:      'center',
  background:     'var(--navy, #0a0e1a)',
};

const headingStyle = {
  color:      'rgba(255,255,255,0.9)',
  fontSize:   '1.15rem',
  fontWeight: 600,
  margin:     0,
};

const subStyle = {
  color:     'rgba(255,255,255,0.5)',
  fontSize:  '0.875rem',
  margin:    0,
  maxWidth:  340,
  lineHeight: 1.6,
};

export function Pending() {
  return (
    <div style={centerStyle}>
      <div className="auth-loading__spinner" />
      <div>
        <p style={headingStyle}>Dein Zugang wartet auf Freigabe</p>
        <p style={{ ...subStyle, marginTop: '0.5rem' }}>
          Du wirst automatisch weitergeleitet, sobald dein Zugang freigeschaltet wurde. Das dauert in der Regel nur wenige Minuten.
        </p>
      </div>
    </div>
  );
}

export function Rejected() {
  return (
    <div style={centerStyle}>
      <span style={{ fontSize: '2.5rem' }}>🚫</span>
      <div>
        <p style={headingStyle}>Zugang nicht freigeschaltet</p>
        <p style={{ ...subStyle, marginTop: '0.5rem' }}>
          Dein Zugang konnte aktuell nicht freigeschaltet werden. Für Fragen wende dich bitte an{' '}
          <a href="mailto:hallo@techsoul-consulting.de" style={{ color: 'var(--cyan, #06b6d4)' }}>
            hallo@techsoul-consulting.de
          </a>
          .
        </p>
      </div>
    </div>
  );
}

export function Blocked({ onLogout }) {
  return (
    <div style={centerStyle}>
      <span style={{ fontSize: '2.5rem' }}>⛔</span>
      <div>
        <p style={headingStyle}>Dieser Zugang ist gesperrt</p>
        <p style={{ ...subStyle, marginTop: '0.5rem' }}>
          Dein Konto wurde gesperrt. Bitte wende dich an den Administrator.
        </p>
      </div>
      {onLogout && (
        <button
          onClick={onLogout}
          style={{
            marginTop:    '0.5rem',
            padding:      '0.55rem 1.4rem',
            borderRadius: '8px',
            border:       '1px solid rgba(255,255,255,0.2)',
            background:   'rgba(255,255,255,0.07)',
            color:        'white',
            fontSize:     '0.9rem',
            cursor:       'pointer',
          }}
        >
          Abmelden
        </button>
      )}
    </div>
  );
}

const StatusPages = { Pending, Rejected, Blocked };
export default StatusPages;
